import React, { useState } from 'react';
import { MdDelete, MdEdit } from 'react-icons/md';

import * as S from './styles';
import AddBtn from 'components/AddBtn';
import { Info } from 'types/BlogProps';
import { returnThumbYoutube } from 'utils/returnJSXs';
import FormToAddContent from 'components/FormToAddContent';

type CreateImgWithRedirectAndLabelProps = {
	textBtn: string;
	contents: Info[];
	// eslint-disable-next-line no-unused-vars
	getContents: (_content: Info[]) => void;
};

export default function CreateImgWithRedirectAndLabel({
	textBtn,
	contents,
	getContents
}: CreateImgWithRedirectAndLabelProps) {
	const [isOpenForm, setIsOpenForm] = useState(false);
	const [contentToEdit, setContentToEdit] = useState<null | Info>(null);

	function deleteContent(content: Info) {
		const newContentArray = contents.filter((value) => value.id !== content.id);
		getContents(newContentArray);
	}

	function addContent(content: Info) {
		const newContentArray = [...contents, content];
		getContents(newContentArray);
	}

	function editContent(content: Info) {
		const newContentsArray = contents.map((value) => {
			if (value.id === content.id) {
				return content;
			}

			return value;
		});
		getContents(newContentsArray);
	}

	function resetForm() {
		setIsOpenForm(false);
		setContentToEdit(null);
	}

	return (
		<S.container>
			<AddBtn
				text={textBtn}
				anyFunction={() => {
					setIsOpenForm(true);
				}}
			/>
			{contents.length > 0 && (
				<S.list>
					{contents.map((content, i) => (
						<S.optionList key={content.id}>
							{returnThumbYoutube(content.urlImg, content.text)}

							<S.infos>
								{content.text && (
									<>
										<b>Posição:</b>
										<p>{`Texto ${i + 1}`}</p>
									</>
								)}
							</S.infos>
							<S.actions>
								<MdDelete
									onClick={() => {
										deleteContent(content);
									}}
								/>
								<MdEdit
									onClick={() => {
										setIsOpenForm(true);
										setContentToEdit(content);
									}}
								/>
							</S.actions>
						</S.optionList>
					))}
				</S.list>
			)}
			{contents.length === 0 && (
				<S.listEmpty>
					<p>Lista vázia</p>
				</S.listEmpty>
			)}
			{isOpenForm && (
				<FormToAddContent
					contentToEdit={contentToEdit}
					excFunctionWhenClicksOnSaveBtn={
						contentToEdit === null ? addContent : editContent
					}
					isOpenForm={isOpenForm}
					resetForm={resetForm}
				/>
			)}
		</S.container>
	);
}
